// eslint-disable-next-line import/prefer-default-export
export const UNEXPANDED_VISIBLE_NOTIFICATIONS = 5;
